var sendSearchRequest = _.debounce(function(){

    $('.search-results-wrapper').load('/search?q=' + encodeURI($('#search').val()) + ' .search-results-wrapper > .search-results');

}, 300);


$(function() {

    $(document).on('submit', '#searchForm', function(e){
        e.preventDefault();
    });

    $(document).on('keyup', '#search', function(e){

        e.preventDefault();
        console.log('output search results');
        sendSearchRequest();

    });

});